import React from "react";
import { makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import { useParams } from "react-router-dom";
import EventStatusListContainer from "../containers/mobile-frame/EventStatusListContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const EventStatusListPage = () => {
  const classes = useStyles();
  let { eklok } = useParams();

  return (
    <Page className={classes.root} title="Event Status List">
      <EventStatusListContainer eklok={eklok} />
    </Page>
  );
};

export default EventStatusListPage;
